import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const SplashScreen = ({ onComplete }) => {
  const { setLanguage } = useLanguage();

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    if (onComplete) onComplete();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-orange-500 to-accent flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 max-w-lg w-full text-center"
      >
        {/* Logo / Title */}
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="text-4xl">🇲🇦</span>
          </div>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-primary mb-2">
            Darija
          </h1>
          <p className="font-nunito text-lg text-charcoal/70">
            L'arabe marocain • Moroccan Arabic
          </p>
        </motion.div>

        {/* Language Selection */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="flex items-center justify-center gap-2 mb-6">
            <Globe className="w-5 h-5 text-charcoal/60" />
            <p className="font-nunito text-base text-charcoal/80">
              Choose your language / Choisissez votre langue
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleLanguageSelect('fr')}
              data-testid="select-french-btn"
              className="tile-button bg-primary text-white font-nunito font-bold py-5 px-6 rounded-xl shadow-[0_5px_0_#9a360b] active:shadow-[0_2px_0_#9a360b] active:translate-y-[3px] transition-all"
            >
              <span className="text-3xl mb-2 block">🇫🇷</span>
              <span className="text-lg">Français</span>
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleLanguageSelect('en')}
              data-testid="select-english-btn"
              className="tile-button bg-secondary text-white font-nunito font-bold py-5 px-6 rounded-xl shadow-[0_5px_0_#004d40] active:shadow-[0_2px_0_#004d40] active:translate-y-[3px] transition-all"
            >
              <span className="text-3xl mb-2 block">🇬🇧</span>
              <span className="text-lg">English</span>
            </motion.button>
          </div>
        </motion.div>

        {/* Footer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-8 font-nunito text-sm text-charcoal/50"
        >
          تعلم الدارجة المغربية
        </motion.p>
      </motion.div>
    </div>
  );
};

export default SplashScreen;
